/* ══════════════════════════════════════════════════════════════════
   Bundle Builder Woo — "Arma tu pack"

   v2 — soporte mobile:
     • Reubica el nodo .bbw__meter entre el sheet (desktop) y la banda
       sticky superior (mobile). Un solo nodo en el DOM, sin duplicar markup.
     • Bottom sheet expandible (data-open) con altura publicada en
       --bbw-sheet-h para que el catálogo reserve espacio.
     • Auto-expande el sheet al agregar el primer producto.

   El descuento real lo aplica la Discount Function en checkout;
   aquí solo mostramos el preview.

   v3 (2026-10) — campaña (Cyber):
     • Si window.WooCampaign.on, cada unidad paga
       floor(precio × (100 − tramo − campaña) / 100): los % se SUMAN
       sobre el precio normal (15% + 20% = 35%), igual que la function
       woo-pack-discount. Desglose en pesos en #bbw-bd-<id>.
     • ?add=<variantId>[,<variantId>…] precarga productos (desde la ficha
       o el carrito). Se re-renderiza al cambiar la campaña (wc:change).
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var MQ_SHEET = '(max-width: 989px)';

  function initSection(root) {
    if (root.dataset.bbwInit === '1') return;
    root.dataset.bbwInit = '1';

    var id = root.dataset.sectionId;
    var T = [
      { min: parseInt(root.dataset.t1, 10) * 100, pct: parseInt(root.dataset.p1, 10) },
      { min: parseInt(root.dataset.t2, 10) * 100, pct: parseInt(root.dataset.p2, 10) },
      { min: parseInt(root.dataset.t3, 10) * 100, pct: parseInt(root.dataset.p3, 10) }
    ];
    var giftHandle = root.dataset.giftHandle || '';

    var $ = function (prefix) { return document.getElementById('bbw-' + prefix + '-' + id); };

    var summaryEl = $('summary');
    var toggleBtn = $('toggle');
    var slotsEl   = $('slots');
    var msgEl     = $('msg');
    var fillEl    = $('fill');
    var origEl    = $('orig');
    var finalEl   = $('final');
    var badgeEl   = $('badge');
    var atcBtn    = $('atc');
    var toastEl   = $('toast');
    var shipEl    = $('ship');
    var shipTextEl = $('ship-text');
    var giftEl    = $('gift');
    var meterEl   = $('meter');
    var meterHome = $('meter-home');
    var meterMount = $('meter-mount');
    var msEls     = Array.prototype.slice.call(root.querySelectorAll('.bbw__ms'));
    var bdEl      = $('bd');

    var shipMin = shipEl ? parseInt(shipEl.dataset.shipMin, 10) * 100 : null;
    var shipTextLocked = shipTextEl ? shipTextEl.textContent.trim() : '';
    var shipTextUnlocked = root.dataset.shipUnlocked || '¡Despacho gratis a domicilio desbloqueado!';

    var items = [];

    /* ── Utilidades ─────────────────────────────────────────────── */
    function money(cents) {
      return '$' + Math.round(cents / 100).toLocaleString('es-CL');
    }
    function subtotal() {
      return items.reduce(function (s, i) { return s + i.price; }, 0);
    }
    function campaignPct() {
      var W = window.WooCampaign;
      return W && W.on && W.cfg && W.cfg.pct > 0 ? W.cfg.pct : 0;
    }
    /* Total a pagar con tramo + campaña (sumados), unidad por unidad (como la function) */
    function payTotal(tierPct, campPct) {
      var t = Math.min(100, tierPct + campPct);
      return items.reduce(function (s, i) {
        var pesos = Math.round(i.price / 100);
        return s + Math.floor(pesos * (100 - t) / 1000) * 1000; // decena hacia abajo, como la function
      }, 0);
    }
    function setBd(key, txt) {
      if (!bdEl) return;
      var el = bdEl.querySelector('[data-bd="' + key + '"]');
      if (el) el.textContent = txt;
    }
    function currentTier(sub) {
      for (var i = T.length - 1; i >= 0; i--) {
        if (sub >= T[i].min) return { index: i, pct: T[i].pct };
      }
      return { index: -1, pct: 0 };
    }

    /* ── Reubicación del meter (mobile ↔ desktop) ───────────────── */
    var mq = window.matchMedia(MQ_SHEET);

    function placeMeter() {
      if (!meterEl || !meterHome || !meterMount) return;
      var target = mq.matches ? meterMount : meterHome;
      if (meterEl.parentNode !== target) target.appendChild(meterEl);
      if (!mq.matches) setOpen(true, true); // desktop: siempre desplegado
      else setOpen(summaryEl.dataset.open === 'true', true);
    }

    /* El header solo desplaza la banda si de verdad es sticky/fixed.
       Si no lo es, --bbw-meter-top = 0 y la banda se pega al borde. */
    function syncMeterTop() {
      var hdr = document.querySelector('.section-header, .shopify-section-group-header-group');
      var offset = 0;
      if (hdr) {
        var pos = window.getComputedStyle(hdr).position;
        if (pos === 'sticky' || pos === 'fixed') offset = hdr.offsetHeight;
      }
      root.style.setProperty('--bbw-meter-top', offset + 'px');
    }

    function onViewportChange() {
      placeMeter();
      syncMeterTop();
    }

    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', onViewportChange);
    else mq.addListener(onViewportChange);
    window.addEventListener('resize', syncMeterTop, { passive: true });

    /* ── Bottom sheet ───────────────────────────────────────────── */
    function setOpen(open, silent) {
      summaryEl.dataset.open = open ? 'true' : 'false';
      if (toggleBtn) {
        toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var lbl = toggleBtn.querySelector('.bbw__sheet-toggle-label');
        if (lbl) lbl.textContent = open ? 'Contraer' : 'Expandir';
      }
      if (!silent) publishSheetHeight();
    }

    if (toggleBtn) {
      toggleBtn.addEventListener('click', function () {
        setOpen(summaryEl.dataset.open !== 'true');
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mq.matches && summaryEl.dataset.open === 'true') setOpen(false);
    });

    /* Publica la altura COLAPSADA del sheet para reservar padding en .bbw.
       Si está abierto, conservamos el último valor (evita saltos de layout). */
    function publishSheetHeight() {
      if (!mq.matches) { root.style.setProperty('--bbw-sheet-h', '0px'); return; }
      if (summaryEl.dataset.open === 'true') return;
      var h = Math.round(summaryEl.getBoundingClientRect().height);
      if (h > 0) root.style.setProperty('--bbw-sheet-h', h + 'px');
    }

    if ('ResizeObserver' in window) {
      new ResizeObserver(publishSheetHeight).observe(summaryEl);
    } else {
      window.addEventListener('resize', publishSheetHeight);
    }

    /* ── Delegación de clicks ───────────────────────────────────── */
    root.addEventListener('click', function (e) {

      // Swatch de color
      var sw = e.target.closest('.bbw-swatch');
      if (sw) {
        var swCard = sw.closest('.bbw-card');
        swCard.querySelectorAll('.bbw-swatch').forEach(function (s) {
          s.classList.remove('is-active');
          s.setAttribute('aria-pressed', 'false');
        });
        sw.classList.add('is-active');
        sw.setAttribute('aria-pressed', 'true');

        var pid = swCard.dataset.productId;
        var priceEl = document.getElementById('bbw-price-' + pid);
        var imgEl = document.getElementById('bbw-img-' + pid);
        var addBtnRef = swCard.querySelector('[data-add]');
        if (priceEl) priceEl.textContent = money(parseInt(sw.dataset.variantPrice, 10));
        if (imgEl && sw.dataset.variantImg) { imgEl.src = sw.dataset.variantImg; imgEl.removeAttribute('srcset'); }
        if (addBtnRef) {
          addBtnRef.dataset.variantId = sw.dataset.variantId;
          addBtnRef.dataset.variantPrice = sw.dataset.variantPrice;
        }
        return;
      }

      // Agregar al pack
      var addBtn = e.target.closest('[data-add]');
      if (addBtn && root.contains(addBtn)) {
        var addCard = addBtn.closest('.bbw-card');
        var activeSwatch = addCard.querySelector('.bbw-swatch.is-active');
        var vId = addBtn.dataset.variantId;
        if (!vId) return;

        var wasEmpty = items.length === 0;
        items.push({
          key: 'k' + Date.now() + Math.random().toString(36).slice(2, 6),
          variantId: vId,
          price: parseInt(addBtn.dataset.variantPrice, 10),
          title: addCard.dataset.productTitle,
          img: (document.getElementById('bbw-img-' + addCard.dataset.productId) || {}).src || '',
          color: activeSwatch ? activeSwatch.dataset.color : ''
        });
        render();

        // Primer producto → abre el sheet para revelar el carrusel
        if (wasEmpty && mq.matches) setOpen(true);
        scrollSlotsToEnd();
        return;
      }

      // Quitar del pack
      var rm = e.target.closest('[data-remove]');
      if (rm) {
        items = items.filter(function (i) { return i.key !== rm.dataset.remove; });
        render();
        return;
      }
    });

    function scrollSlotsToEnd() {
      if (!mq.matches) return;
      requestAnimationFrame(function () {
        slotsEl.scrollTo({ left: slotsEl.scrollWidth, behavior: 'smooth' });
      });
    }

    /* ── Render ─────────────────────────────────────────────────── */
    function render() {
      var sub = subtotal();
      var tier = currentTier(sub);

      // Slots
      slotsEl.innerHTML = '';
      items.forEach(function (item) {
        var li = document.createElement('li');
        li.className = 'bbw__slot';
        li.innerHTML =
          '<button type="button" class="bbw__slot-remove" data-remove="' + item.key + '" aria-label="Quitar ' + item.title + '">&times;</button>' +
          (item.img
            ? '<img src="' + item.img + '" alt="" class="bbw__slot-img" width="60" height="60">'
            : '<span class="bbw__slot-img"></span>') +
          '<span class="bbw__slot-info"><span class="bbw__slot-title">' + item.title + '</span>' +
          (item.color ? '<span class="bbw__slot-color">' + item.color + '</span>' : '') + '</span>';
        slotsEl.appendChild(li);
      });

      var empty = document.createElement('li');
      empty.className = 'bbw__slot bbw__slot--empty';
      empty.innerHTML = '<span aria-hidden="true">+</span>';
      slotsEl.appendChild(empty);

      // Fill: dots en 10% / 50% / 90%; el fill nace en el borde izquierdo
      var pctFill;
      if (sub <= 0) pctFill = 0;
      else if (sub < T[0].min) pctFill = (sub / T[0].min) * 10;
      else if (sub < T[1].min) pctFill = 10 + ((sub - T[0].min) / (T[1].min - T[0].min)) * 40;
      else if (sub < T[2].min) pctFill = 50 + ((sub - T[1].min) / (T[2].min - T[1].min)) * 40;
      else pctFill = 100;
      fillEl.style.width = Math.min(100, pctFill) + '%';

      msEls.forEach(function (ms) {
        ms.classList.toggle('is-reached', sub >= parseInt(ms.dataset.min, 10) * 100);
      });

      var camp = campaignPct();
      var campLbl = camp ? ((window.WooCampaign.cfg.label || 'Cyber') + ' ' + camp + '%') : '';

      // Mensaje
      if (tier.index === -1) {
        msgEl.textContent = camp
          ? 'Agrega ' + money(T[0].min - sub) + ' y sumas ' + T[0].pct + '% extra al ' + campLbl
          : 'Agrega ' + money(T[0].min - sub) + ' y obtén ' + T[0].pct + '% de descuento';
      } else if (tier.index < 2) {
        var next = T[tier.index + 1];
        msgEl.textContent = camp
          ? 'Agrega ' + money(next.min - sub) + ' más y pasas a ' + (camp + next.pct) + '% off' + (tier.index + 1 === 2 ? ' + regalo' : '')
          : 'Agrega ' + money(next.min - sub) + ' más y obtén ' + next.pct + '% de descuento';
      } else {
        msgEl.textContent = camp
          ? '¡Máximo desbloqueado: ' + (camp + T[2].pct) + '% off + regalo!'
          : '¡Máximo ' + T[2].pct + '% de descuento desbloqueado!';
      }

      // Totales
      var pay = payTotal(tier.pct, camp);
      if ((tier.pct > 0 || camp > 0) && sub > 0) {
        origEl.textContent = money(sub);
        origEl.hidden = false;
        finalEl.textContent = money(pay);
        finalEl.classList.add('is-discounted');
        badgeEl.textContent = '-' + Math.floor((sub - pay) * 100 / sub) + '%';
        badgeEl.hidden = false;
      } else {
        origEl.hidden = true;
        finalEl.textContent = money(sub);
        finalEl.classList.remove('is-discounted');
        badgeEl.hidden = true;
      }

      // Desglose en pesos (solo con campaña)
      if (bdEl) {
        if (camp > 0 && sub > 0) {
          var campOnly = payTotal(0, camp);
          setBd('orig', money(sub));
          setBd('camp-lbl', campLbl);
          setBd('camp', '−' + money(sub - campOnly));
          setBd('tier-lbl', tier.pct > 0 ? 'Arma tu pack ' + tier.pct + '%' : 'Arma tu pack (desde ' + money(T[0].min) + ')');
          setBd('tier', tier.pct > 0 ? '−' + money(campOnly - pay) : '—');
          setBd('save', 'Ahorras ' + money(sub - pay));
          setBd('savepct', String(Math.floor((sub - pay) * 1000 / sub) / 10).replace('.', ',') + '% menos');
          bdEl.hidden = false;
        } else {
          bdEl.hidden = true;
        }
      }

      atcBtn.disabled = items.length === 0;

      // Banner de despacho
      if (shipEl && shipMin !== null) {
        var unlocked = sub >= shipMin;
        shipEl.classList.toggle('is-unlocked', unlocked);
        if (shipTextEl) shipTextEl.textContent = unlocked ? shipTextUnlocked : shipTextLocked;
      }

      // Regalo
      if (giftEl) giftEl.hidden = sub < T[2].min;

      publishSheetHeight();
    }

    /* ── Agregar pack al carrito ────────────────────────────────── */
    atcBtn.addEventListener('click', function () {
      if (items.length === 0) return;
      atcBtn.disabled = true;
      atcBtn.textContent = 'Agregando…';

      var grouped = {};
      items.forEach(function (i) { grouped[i.variantId] = (grouped[i.variantId] || 0) + 1; });
      var payload = Object.keys(grouped).map(function (vid) {
        return { id: parseInt(vid, 10), quantity: grouped[vid], properties: { '_pack': 'arma-tu-pack' } };
      });

      var reachedGift = subtotal() >= T[2].min && giftHandle;
      var chain = Promise.resolve();

      if (reachedGift) {
        chain = fetch('/products/' + giftHandle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (gp) {
            if (gp && gp.variants && gp.variants[0]) {
              payload.push({ id: gp.variants[0].id, quantity: 1, properties: { '_pack_gift': 'true' } });
            }
          })
          .catch(function () {});
      }

      chain
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: payload })
          });
        })
        .then(function (res) { if (!res.ok) throw new Error('cart'); return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var bubble = document.querySelector('.cart-count-bubble span[aria-hidden]');
          if (bubble) bubble.textContent = cart.item_count;
          showToast('¡Pack agregado! ' + items.length + ' productos' + (reachedGift ? ' + regalo 🎁' : ''));
          atcBtn.textContent = 'Ver carrito';
          atcBtn.disabled = false;
          atcBtn.onclick = function () { window.location.href = '/cart'; };
        })
        .catch(function () {
          atcBtn.textContent = 'No se pudo agregar — reintentar';
          atcBtn.disabled = false;
        });
    });

    function showToast(msg) {
      toastEl.textContent = msg;
      toastEl.classList.add('is-visible');
      clearTimeout(toastEl._t);
      toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 3500);
    }

    /* ── Precarga ?add=<variantId>,… (ficha / carrito) ────────────── */
    function preloadFromUrl() {
      var raw = '';
      try { raw = new URLSearchParams(window.location.search).get('add') || ''; } catch (e) { return; }
      var ids = raw.split(',').map(function (x) { return x.trim(); }).filter(function (x) { return /^\d+$/.test(x); }).slice(0, 12);
      if (!ids.length) return;
      var added = 0;
      ids.forEach(function (vid) {
        var sw = root.querySelector('.bbw-swatch[data-variant-id="' + vid + '"]');
        var card = sw ? sw.closest('.bbw-card') : null;
        var btn = null;
        if (card) {
          sw.click(); // selecciona color/precio/imagen de esa variante
          btn = card.querySelector('[data-add]');
        } else {
          btn = root.querySelector('[data-add][data-variant-id="' + vid + '"]');
        }
        if (btn) { btn.click(); added++; }
      });
      if (added && !mq.matches && summaryEl.scrollIntoView) {
        summaryEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    /* ── Arranque ───────────────────────────────────────────────── */
    placeMeter();
    syncMeterTop();
    render();
    publishSheetHeight();
    preloadFromUrl();
    document.addEventListener('wc:change', render);

    // El header de Dawn/Sense fija --header-height tras cargar fuentes/logo.
    window.addEventListener('load', syncMeterTop);
  }

  function boot() {
    document.querySelectorAll('.bbw[data-section-id]').forEach(initSection);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.bbw[data-section-id]');
    if (el) { delete el.dataset.bbwInit; initSection(el); }
  });
})();
